var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDareyPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 22.6668V21.0002C16.8333 18.699 14.9678 16.8335 12.6667 16.8335C10.3655 16.8335 8.5 18.699 8.5 21.0002V22.6668H16.8333ZM16.8333 22.6668H23.5V21.8335C23.5 19.3789 21.6345 17.6668 19.3333 17.6668C18.1556 17.6668 17.0919 18.1881 16.3341 19.0261M15.1667 11.8335C15.1667 13.2142 14.0474 14.3335 12.6667 14.3335C11.286 14.3335 10.1667 13.2142 10.1667 11.8335C10.1667 10.4528 11.286 9.3335 12.6667 9.3335C14.0474 9.3335 15.1667 10.4528 15.1667 11.8335ZM21 13.5002C21 14.4207 20.2538 15.1668 19.3333 15.1668C18.4128 15.1668 17.6667 14.4207 17.6667 13.5002C17.6667 12.5797 18.4128 11.8335 19.3333 11.8335C20.2538 11.8335 21 12.5797 21 13.5002Z",
    stroke: "#2C3E4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDareyPeople);
export default __webpack_public_path__ + "static/media/darey-people.07b8599a318ddc82e60d5d44ff2657e4.svg";
export { ForwardRef as ReactComponent };